import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadImageCautionArea = _resolveComponent("UploadImageCautionArea")!
  const _component_FormSelectGroup = _resolveComponent("FormSelectGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_QualificationImage = _resolveComponent("QualificationImage")!
  const _component_UploadImageForm = _resolveComponent("UploadImageForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isVerified)
      ? (_openBlock(), _createBlock(_component_UploadImageCautionArea, {
          key: 0,
          cautions: _ctx.cautions,
          class: "mb-4"
        }, null, 8, ["cautions"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_ValidationProvider, {
      name: "資格",
      tag: "div",
      rules: "required",
      vid: "qualification"
    }, {
      default: _withCtx((validationState) => [
        _createVNode(_component_FormSelectGroup, {
          label: "資格種別",
          appLabelText: "必須",
          modelValue: _ctx.inputValues.qualification,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues.qualification) = $event)),
          options: _ctx.qualificationOptions,
          "text-field": "name",
          "value-field": "id",
          "validation-state": validationState,
          class: "mb-4",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "options", "validation-state", "disabled"])
      ]),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_UploadImageForm, {
      modelValue: _ctx.inputValues.image,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValues.image) = $event)),
      photoGraphingType: "qualification",
      appLabelText: "必須",
      appLabelVariant: "red",
      isFrontCamera: false,
      isCameraActive: _ctx.isCameraActiveValue,
      "onUpdate:isCameraActive": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isCameraActiveValue) = $event)),
      options: _ctx.options,
      disabled: _ctx.disabled,
      disabledText: _ctx.disabledText
    }, {
      default: _withCtx(() => [
        _createVNode(_component_QualificationImage, {
          imageUrl: _ctx.inputValues.image
        }, null, 8, ["imageUrl"])
      ], undefined, true),
      _: 1
    }, 8, ["modelValue", "isCameraActive", "options", "disabled", "disabledText"])
  ]))
}